module.exports = {"330371005":"海城街道","330371008":"沙城街道","330371009":"天河街道","330371011":"星海街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330371.json
// module id = 1078
// module chunks = 0